// extracted by mini-css-extract-plugin
export default {"wrapper":"DrawerContainer_wrapper__fLtRG","container":"DrawerContainer_container__xs16W","closeImg":"DrawerContainer_closeImg__sadtY"};